module.exports = __webpack_public_path__ + "static/media/400090_01.82dcf978.png";